<template>
  <div class="project_info_data d_flex flex_direction_col fz12 c_1A1A1A">

    <div class="notice-w">
      <div class="problem_head d_flex justify_content_sb">
        <span class="problem_node_title font_w_bold">{{
          noticeColumn.name
        }}</span>
      </div>
      <div class="problem_list" :style="{ height : isShowBidList ? '127px': '304px'} ">
        <ul>
          <li
            v-for="item in noticeColumn.children"
            :key="item.id"
            class="link-item text_ellipsis"
          >
            <router-link :to="`${item.nodeModel.route}/${item.id}`" :title="item.name">{{
              item.name
            }}</router-link>
          </li>
        </ul>

        <Emtry v-if="!noticeColumn.children.length" />
      </div>
    </div>
  </div>
</template>

<script>
import { regMobile, numTranFloat, findItemByArr } from '@/utils'
import { mapGetters } from 'vuex'
import Emtry from '@/components/base/Emtry.vue'

export default {
  components: {
    Emtry
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['siteInfo']),

    numTranFloat() {
      return function(num) {
        return numTranFloat(num)
      }
    },
    // 公告节点
    noticeColumn() {
      return findItemByArr(this.siteInfo.nodes, 'code', 'problem')
    },
    isShowBidList() {
      return true
    }
  },
  created() {
  },
  mounted() {
    console.log('this.siteInfo.nodes', this.siteInfo.nodes)
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
.project_info_data {
  width: 318px;
  border: 1px solid #e6e6e6;
  display: flex;
  flex-direction: column;
  .notice-w{
    flex: 1;
  }
  .new_bid_w {
    flex: 1;
  }
  .problem_head {
    padding: 10px 10px 0 20px;
    border-bottom: 1px solid #e6e6e6;
  }
  .problem_list {
    overflow-x: hidden;
    overflow-y: scroll;
    margin: 6px 0;
    padding: 0 20px;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #e6e6e6;
    }
    .link-item {
      padding: 10px 0;
      border-bottom: 1px solid #e6e6e6;
      font-size: 12px;
      &:last-child {
        border: 0;
      }
    }
  }
  .record_title {
    padding: 9px 19px 8px 19px;
    background-color: #e5eef6;
  }
  .record_list {
    padding: 0 20px;
    & li {
      padding: 10px 0 6px 0;
      border-bottom: 1px solid #e6e6e6;
      &:last-child {
        border: 0;
      }
      p {
        &:first-child {
          margin: 0 0 5px 0;
        }
      }
    }
  }

  .problem_node_title {
    padding: 0 0 6px 0;
    border-bottom: 2px solid #0983cc;
  }
}
</style>
